const isDevelopment = process.env.NODE_ENV === 'development'

const apiUrl = import.meta.env.VITE_API_URL

if (apiUrl === undefined) {
  console.warn(
    'VITE_API_URL is not defined. Using relative paths for API requests.'
  )
}

export const API_URL = apiUrl || ''

export const API_CONFIG = {
  baseUrl: import.meta.env.VITE_API_URL,
  youtube: {
    baseUrl: 'https://www.googleapis.com/youtube/v3'
  }
} 